import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		server: undefined,
		func: 3,
		operation: 2,
		node: 14,
		refresh: 10000,
		haveBlocks: true
	}
});

export default app;
